import {
  Link as LinkUIKit,
  LinkProps as LinkPropsUIKit,
} from "@gravity-ui/uikit";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

interface LinkProps extends Omit<LinkPropsUIKit, "href"> {
  children: React.ReactNode;
  to: string;
}

export const Link = ({ children, to, ...props }: LinkProps) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(to);
  }, [navigate, to]);

  return (
    <LinkUIKit {...props} href={"#"} onClick={onClick}>
      {children}
    </LinkUIKit>
  );
};
